<p
  *ngIf="policy === 'easy' || showAll"
  [ngClass]="{ highlighted: policy === 'easy' && showAll, 'fine-print': finePrint }"
  class="fine-print"
>
  <span class="semi-bold">Easy Goin&rsquo; - Free Cancellation - </span>
  <span class="cancellation-description">{{ getCancellationPolicyString('easy') }}</span>
</p>
<hr *ngIf="showAll" />
<p
  *ngIf="policy === 'moderate' || showAll"
  [ngClass]="{ highlighted: policy === 'moderate' && showAll, 'fine-print': finePrint }"
>
  <span class="semi-bold">Moderate - Free Cancellation - </span>
  <span class="cancellation-description">{{ getCancellationPolicyString('moderate') }}</span>
</p>
<hr *ngIf="showAll" />
<p
  *ngIf="policy === 'strict' || showAll"
  [ngClass]="{ highlighted: policy === 'strict' && showAll, 'fine-print': finePrint }"
>
  <span class="semi-bold">Strict - Partial Refund - </span>
  <span class="cancellation-description">{{ getCancellationPolicyString('strict') }}</span>
</p>
<hr *ngIf="showAll" />
<p
  *ngIf="policy === 'exclusive' || showAll"
  [ngClass]="{ highlighted: policy === 'exclusive' && showAll, 'fine-print': finePrint }"
>
  <span class="semi-bold">Exclusive - Non-Refundable - </span>
  <span class="cancellation-description">{{ getCancellationPolicyString('exclusive') }}</span>
</p>
